// extracted by mini-css-extract-plugin
export default {"image":"icon_image__YfzBL"};